// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__OxlFZ","colBig":"styles_colBig__3xya3","colSmall":"styles_colSmall__3ebC2"};